
import DOMPurify from 'dompurify';

const AboutRisk = () => {
    const links = [
        {
            title: 'Свидетельство <br/> об авторском праве 1',
            link: '/static/docs/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D1%81%D0%BA%D0%BE%D0%B5_%D0%BF%D1%80%D0%B0%D0%B2%D0%BE_1.pdf'
        },
        {
            title: 'Свидетельство <br/> об авторском праве 2',
            link: '/static/docs/%D0%90%D0%B2%D1%82%D0%BE%D1%80%D1%81%D0%BA%D0%BE%D0%B5_%D0%BF%D1%80%D0%B0%D0%B2%D0%BE_2.pdf'
        },
        {
            title: 'Сведения <br/> о правообладателях ПО',
            link: '/static/docs/%D0%9F%D1%80%D0%B0%D0%B2%D0%BE%D0%BE%D0%B1%D0%BB%D0%B0%D0%B4%D0%B0%D1%82%D0%B5%D0%BB%D0%B8_%D0%9F%D0%9E.pdf'
        },
        {
            title: 'Свидетельство <br/> о регистрации программы для ЭВМ №2017614533 Ключ-АСТРОМ',
            link: 'https://ruscomtech.ru/static/docs/Регистрация_программы.pdf'
        },
        {
            title: '',
            link: ''
        },
        {
            title: 'Свидетельство <br/> на товарный знак №606227 Ключ-АСТРОМ',
            link: '/static/docs/ip-ka.pdf'
        }
    ]
    return (
        <div className="w-full h-full flex flex-wrap justify-center items-center">
            <div className="w-full xl:w-[1000px] h-[82px] lg:h-[153px] flex-col justify-center items-center gap-10 inline-flex bg-about-risk rounded-[20px]">
                <div className="text-center text-white text-[10px] lg:text-xl font-semibold font-['Open Sans']">
                    Наши заказчики полностью защищены <br />
                    от санкционных рисков, поскольку <br />
                    продукт импортонезависим.
                </div>
            </div>
            <div className="w-full xl:w-[936px] text-center text-[#544a28] text-[10px] lg:text-xl font-normal font-['Open Sans'] mt-[60px]">
                На текущий момент (в условиях санкционных ограничений) компания <br />
                занимается поставкой лицензий, технической поддержкой и реализацией<br />
                проектов по внедрению решения.
            </div>

            <div className="w-full max-w-full xl:w-[1062px] mt-[40px] flex flex-wrap cols-2 justify-between items-center gap-10">
                {links.map((link, index) => (
                    <div className="w-full flex flex-row gap-4 xl:w-[443px]" key={index}>
                        <div key={index} className="w-full xl:w-[262px] text-[#544a28] text-[14px] lg:text-xl font-semibold font-['Open Sans']"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(link.title) }}>
                            
                        </div>
                        {link.link && (
                            <div className="w-full xl:w-[108px] h-auto rounded-[5px] lg:justify-start justify-center items-center gap-4 inline-flex">
                            <a href={link.link} className="px-5 py-2.5 bg-[#c0834d] rounded-[20px] justify-center items-center gap-2.5 flex" target='_blank'>
                                <div className="text-white text-[14px] lg:text-base font-bold font-['Open Sans']">Скачать</div>
                                </a>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
            );
}

            export default AboutRisk;